import React from 'react'
import './Navbar.css'

function Navbar() {
    return (
        <div className='nav-cont'>
            <h2 className='nav-title'>Meme Generator</h2>
            <h5 className='nav-des'>React Course - Project 3</h5>
        </div>
    )
}

export default Navbar
